<template>
<div class="Individualization">
    <div class="banner">
        <div class="page-module">
            <div class="card-left">
                <p class="name animated fadeInUp">个性化需求定制服务</p>
                <p class="msg animated fadeInUp">从客户痛点出发，专注解决各种股权问题</p>
                <div class="button animated fadeInUp">
                    <button class="btn-style" @click="goto()">留言咨询<div class="line"></div></button>
                </div>
            </div>
            <div class="card-right">
                <img class="img-1 animated fadeInUp" src="~common/images/gujing/individualization/bg.png" alt="1">
                <img class="img-2 animated fadeInUp" src="~common/images/gujing/individualization/bg1.png" alt="1">
            </div>
        </div>
    </div>
    <!-- end banner -->

    <div class="xx-student">
        <div class="page-module animated">
            <p class="name">股权协议合同拟定</p>
            <img src="~common/images/gujing/individualization/ht.png" alt="1">
            <span>协议合同只做展示用途，以上为部分模版展示。</span>
        </div>
    </div>
    <!-- end 线下课程 -->

    <div class="dz bg-F5F7FA">
        <div class="page-module animated">
           <p class="name">远程定制股权方案</p>
           <div class="msg">
              <li>
                <img src="~common/images/gujing/individualization/icon (2).png" alt="1">
                <p class="title">明确需求</p>
                <span>按照一定的模式与格式收集客户信息，咨询师指导客户清晰和明确自身需求</span>
              </li>
              <li>
                <img src="~common/images/gujing/individualization/icon (3).png" alt="1">
                <p class="title">方案设计</p>
                <span>根据行业特性、发展阶段、企业特点、股东想法等因素，凭借咨询师丰富经验形成方案初稿</span>
              </li>
              <li>
                <img src="~common/images/gujing/individualization/icon (4).png" alt="1">
                <p class="title">方案定稿</p>
                <span>专业咨询师与客户远程沟通讨论，针对核心关键问题分析并决策，形成最终落地方案</span>
              </li>
              <li>
                <img src="~common/images/gujing/individualization/icon (5).png" alt="1">
                <p class="title">配套文件</p>
                <span>咨询师根据最终方案，协助客户修改股权转让、合作、投资等相关配套文件</span>
              </li>
           </div>
        </div>
    </div>
    <!-- end 远程定制股权方案 -->

   
    <div class="item-2 item">
        <div class="page-module animated">
            <p class="name">更多股权相关服务</p>
            <div class="left-content">
                <div class="msg">
                    <p class="type">股权激励全案服务</p>
                    <p>项目深度调研、股权激励方案设计、培训宣讲落地实施、长期动态优化调整</p>
                    <p class="type">常年资本顾问服务</p>
                    <p>远程24h会议沟通、上市规划建议指导、融资并购建议指导、企业股权问题建议</p>
                    <p class="type">定制商业计划书</p>
                    <p>投资视角下商业模式优化、企业价值评估、资本运营规划、融资路演指导</p>
                    <p class="type">股权融资顾问服务</p>
                    <p>挖掘企业投资亮点、定制优化融资方案、高效匹配投资机构、投资条款投资协议修改</p>
                </div>
            </div>
            <div class="right-img">
                <img src="~common/images/gujing/individualization/item.png" alt="1">
            </div>
        </div>
    </div>
    <!-- end 更多股权相关服务 -->

    <LeavingAMessage :code="'A01'"></LeavingAMessage>
    <!-- end 留言 -->

    <!-- <div class="telme">
        <p>13556826075</p>
        <img src="~common/images/gujing/equityLearning/lxwo.png" alt="lxwm" width="50px">
    </div> -->
</div>
</template>

<script>
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
import LeavingAMessage from '../components/LeavingAMessage.vue'
import "animate.css/animate.min.css"
export default {
    name: 'Individualization',
    data() {
        return {
        }
    },
    //判断pc或者移动，然后路由跳转
    created() {
        // console.log('this.domainInfo.isMobile',this.domainInfo)
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MIndividualization'
            })
        }
    },
    mounted() {
        // if (this.isIE() == true) {
            $('.gj-footer').css("margin-top","0")
        // }

        $('html').scrollTop(0)
        $(".gj_header").addClass('gj_top_header')
        if (this.animationScrool) {
            window.addEventListener('scroll', this.animationScrool)
        }
        this.animationScrool()
        $(window).bind("scroll",function(){  
            if (this.animationScrool) {
                this.animationScrool()
            }
        });
    },
    methods: {
        animationScrool() { // 鼠标滚动事件监控，进行动画 top 动画事件
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            // console.log(scrollTop)
            // 添加滚动条
            if (this.$route.name == "Individualization") {
                if (scrollTop > 10) {
                    if ($(".gj_header").hasClass('gj_top_header')) {
                        $(".gj_header").removeClass('gj_top_header')
                    }
                }
                if (scrollTop == 0) {
                    $(".gj_header").addClass('gj_top_header')
                }
            }

            if (scrollTop >= 0 && scrollTop < 1200) {
                if (!$(".xx-student  .page-module").hasClass('fadeInUp')) {
                    $(".xx-student .page-module").addClass('fadeInUp')
                }
            }
             if (scrollTop > 600 && scrollTop < 1800) {
                if (!$(".dz .page-module").hasClass('fadeInUp')) {
                    $(".dz .page-module").addClass('fadeInUp')
                }
            }

            if (scrollTop > 1100 && scrollTop < 2400) {
                if (!$(".item-2 .page-module").hasClass('fadeInUp')) {
                    $(".item-2 .page-module").addClass('fadeInUp')
                }
            }
            if (scrollTop > 1800) {
                 if (!$(".LeavingAMessage .page-module").hasClass('fadeInUp')) {
                    $(".LeavingAMessage .page-module").addClass('fadeInUp')
                }
             }
            
        },
        goto() {    // 跳转
            // if (this.user.isLogin) {
                // 跳转到估值页面
                // this.$router.push({name: 'ExcitationStep'})
                $('html').scrollTop(3000)
            // } else {
                // 登录弹窗
                // this.setLoginPop(true)
            // }
        },
        isIE() { //ie?  
            if (!!window.ActiveXObject || "ActiveXObject" in window) { return true; }  
            else { return false; }  
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'domainlist',
            'domainInfo'
        ])
    },
    destroyed() {
        $('.gj-footer').css("margin-top","40px")
        $(".gj_header").removeClass('gj_top_header')
    },
    components: {
        LeavingAMessage
    }
}
</script>
<style lang="scss" type="text/scss" scoped>
.Individualization {
    background: #fff;
    // background-color: rgb(225, 236, 193);
    // padding-top: 64px;
    .banner {
        height: 500px;
        background: url('../../../common/images/gujing/gz/banner-bg.png') no-repeat center;
        background-size: 1920px 500px;

        .card-left {
            float: left;
            margin-top: 114px;
            p {
                color: #fff;
            }
            .name {
                font-size: 40px;
                font-weight:500;
                text-align: left;
                &::before {
                    content: '';
                    display: none;
                }
            }
            .msg {
                margin-top: 37px;
                font-size: 20px;
            }
            .button {
                width: 180px;
                
                .btn-style {
                    position: relative;
                    overflow: hidden;
                    margin-top: 60px;
                    width:180px;
                    height:50px;
                    background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -webkit-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -ms-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -moz-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    background: -o-linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                    border-radius:25px;
                    border: none;
                    cursor: pointer;
                    color: #fff;
                    font-size: 20px;

                    &:hover {
                        .line {
                            left: 160px;
                            transition: all .6s;
                            -webkit-transition: all .6s;
                            -ms-transition: all .6s;
                            -o-transition: all .6s;
                            -moz-transition: all .6s;
                        }
                    }
                    .line {
                        position: absolute;
                        width: 100px;
                        height: 25px;
                        background: rgba(255,255,255,.3);
                        transform: rotateZ(45deg);
                        bottom: 15px;
                        left: -80px;
                        transition: all 0;
                        -webkit-transition: all 0;
                        -ms-transition: all 0;
                        -o-transition: all 0;
                        -moz-transition: all 0;
                    }
                }
            }
        }
        .card-right {
            float: right;
            position: relative;
            margin-top: 89px;
            margin-right: 45px;
            width: 622px;
            height: 312;
            .img-1 {
                width: 100%;
                height: 100%;
            }
            .img-2 {
                position: absolute;
                left: 279px;
                top: 121px;
                width: 52px;
                height: 89px;
                animation: imganimation 2s;
                -webkit-animation: imganimation 2s;
                -ms-animation: imganimation 2s;
                -moz-animation: imganimation 2s;
                -o-animation: imganimation 2s;
                animation-iteration-count: infinite;
                -webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
                animation-direction:alternate;
                -webkit-animation-direction:alternate; /* Safari 和 Chrome */
            }
           
            @keyframes imganimation {
                0% {
                    top: 131px;
                }
                100% {
                    top: 121px;
                }
            }
        }
    }
   
    .bg-F5F7FA {
        background: #F5F7FA;
    }
    .xx-student {
        padding: 60px 0;
        .page-module {
            opacity: 0;
        }
        span {
          display: block;
          color: #999999;
          margin-top: 40px;
          text-align: center;
        }
        img {
            margin: auto;
            margin-top: 52px;
            width: 1180px;
        }
    }
    .name {
                position: relative;
                text-align: center;
                padding: 10px 0;
                font-size: 26px;
                color: #333;
                &::before {
                    content: '';
                    position: absolute;
                    margin: auto;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width:36px;
                    height:2px;
                    background: #409EFF;
                }
    }

    .dz {
      padding: 60px 0 80px 0;
      height: 560px;
      box-sizing: border-box;
      .page-module {
        opacity: 0;
      }
      li {
        float: left;
        margin-top: 93px;
        width:220px;
        height:290px;
        background:rgba(255,255,255,1);
        border-radius:6px;
        padding: 30px 40px 20px 40px;
        box-sizing: border-box;
        &~li {
          position: relative;
          margin-left: 93px;
          &::before {
            content: '';
            display: block;
            position: absolute;
            margin: auto;
            left: -69px;
            top: 0;
            bottom: 0;
            width: 45px;
            height: 27px;
            background: url('../../../common/images/gujing/individualization/icon (1).png') no-repeat;
            background-size: 45px 27px;
            background-position-y: center;
            background-position-x: left;
          }
        }
        img {
          margin: auto;
          width: 68px;
          height: 68px;
        }
        .title {
          text-align: center;
          margin-top: 20px;
          font-size: 20px;
        }
        span {
          display: block;
          font-size: 14px;
          color: #666;
          margin-top: 20px;
          line-height: 20px;
        }
      }
    }
   
   
   .item {
        padding: 56px 0 77px 0;
        .animated {
            opacity: 0;
        }
        .fadeInUp {
            opacity: 1;
        }
        .left-content {
            float: left;
            width: 570px;
            .name {
                position: relative;
                font-size: 26px;
                color: #333;
                text-align: left;
                &::before {
                    content: '';
                    position: absolute;
                    margin: 0;
                    bottom: -10px;
                    width:36px;
                    height:2px;
                    background: #409EFF;
                }
            }
            .msg {
                margin-top: 38px;
                font-size: 16px;
                color: #666;
                line-height: 24px;
            }
        }
        .right-img {
            float: left;
            margin-left: 134px;
            img {
                width: 318px;
                height: 237px;
            }
        }

        &.item-2 {
            padding: 60px 0 159px 0;
            .name {
              margin-bottom: 67px;
            }
            img {
                width: 522px;
                height: 346px;
            }
            .msg {
                p {
                    font-size: 16px;
                    color: #666;
                    &~p {
                      margin-top: 10px;
                    }
                    &.type {
                      margin-top: 25px;
                        font-size: 20px;
                        color: #409EFF;
                    }
                }
            }
            .left-content {
                float: right;
                width: 610px;
            }
            .right-img {
                margin-left: 0
            }
        }
       
    }
    .margin-0 {
        margin-left: 0 !important;
    }
   
   
    .telme {
        position: fixed;
        z-index: 2;
        box-sizing: border-box;
        right: 0;
        bottom: 50px;
        width: 50px;
        height: 50px;
        background: #409EFF;
        color: #fff;
        font-size: 14px;
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        -moz-transition: all .5s;
        p {
            display: none;
            line-height: 50px;
        }
        &:hover {
            padding: 0 11px;
            line-height: 50px;
            width: 150px;
            font-size: 16px;
            transition: all .6s;
            -webkit-transition: all .6s;
            -ms-transition: all .6s;
            -o-transition: all .6s;
            -moz-transition: all .6s;
            img {
                display: none;
            }
            p {
                display: block;
                padding-left: 25px;
                background: url("../../../common/images/gujing/phone2.png") no-repeat;
                background-position-x: left;
                background-position-y: center;
                background-size: 19px 20px;
            }
        }
    }
    
}
</style>